import React from 'react'
import { ActivityIndicator, Text, TouchableOpacity, View } from 'react-native'

/**
 * Titled card that groups one Hall of Fame section. Handles its own loading
 * and error states so one failed query doesn't blank the whole page.
 */
export function HofSectionCard({
  title,
  subtitle,
  isLoading,
  error,
  onRetry,
  footer,
  headerAccessory,
  testID,
  children,
}: {
  title: string
  subtitle?: string
  isLoading?: boolean
  error?: unknown
  onRetry?: () => void
  footer?: React.ReactNode
  /** Rendered at the right of the title row, e.g. a help button. */
  headerAccessory?: React.ReactNode
  testID?: string
  children?: React.ReactNode
}) {
  return (
    <View testID={testID} className="bg-paper border-2 border-olive rounded-xl p-4 gap-3">
      <View className="flex-row items-start gap-3">
        <View className="flex-1 gap-0.5">
          <Text className="font-stencil text-ink uppercase text-sm tracking-widest">{title}</Text>
          {subtitle ? <Text className="font-typed text-ink-soft text-xs">{subtitle}</Text> : null}
        </View>
        {headerAccessory}
      </View>
      {isLoading ? (
        <View className="py-6 items-center">
          <ActivityIndicator color="#8aa14a" />
        </View>
      ) : error ? (
        <View className="items-center gap-2 py-3">
          <Text className="font-typed text-ink-soft text-xs">Couldn't load this section.</Text>
          {onRetry && (
            <TouchableOpacity
              onPress={onRetry}
              className="bg-paper-up border border-olive rounded-md px-4 py-2"
              accessibilityLabel={`Retry ${title}`}
              accessibilityRole="button"
            >
              <Text className="font-stencil text-ink">Retry</Text>
            </TouchableOpacity>
          )}
        </View>
      ) : (
        <>
          {children}
          {footer}
        </>
      )}
    </View>
  )
}
